export const getRecaptchaToken = (recaptchaKey, actionName = 'submit') => new Promise((resolve, reject) => {
  // eslint-disable-next-line no-undef
  grecaptcha.ready(() => {
    try {
      // eslint-disable-next-line no-undef
      grecaptcha.execute(recaptchaKey, { action: actionName })
        .then((token) => {
          resolve(token);
        });
    } catch (error) {
      reject(error);
    }
  });
});

export const addCaptchaToForm = async (formSelector, symfonyFormName) => {
  const form = document.getElementById(formSelector);

  if (!form) {
    return;
  }

  const inputName = `${symfonyFormName}[g-recaptcha-token]`;
  let existingCaptcha = form.querySelector(`input[name="${inputName}"]`);

  if (!existingCaptcha) {
    existingCaptcha = document.createElement('input');
    existingCaptcha.type = 'hidden';
    existingCaptcha.name = inputName;
  }

  existingCaptcha.value = await getRecaptchaToken(window.recaptcha, 'contact');

  form.appendChild(existingCaptcha);
};
